var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wx-open-launch-weapp',{attrs:{"id":"launch-btn","username":_vm.env.originId,"path":_vm.url},on:{"launch":_vm.launch}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }